import { useStaticQuery, graphql } from "gatsby"

const useLayoutQuery = () => {
  return useStaticQuery(graphql`
    fragment WpSeo on WpPostTypeSEO {
      metaDesc
      metaKeywords
      metaRobotsNofollow
      opengraphAuthor
      opengraphDescription
      opengraphImage {
        localFile {
          publicURL
        }
      }
      opengraphModifiedTime
      opengraphPublishedTime
      opengraphPublisher
      opengraphSiteName
      opengraphTitle
      opengraphType
      opengraphUrl
      readingTime
      schema {
        articleType
        pageType
        raw
      }
      title
      twitterDescription
      twitterImage {
        localFile {
          publicURL
        }
      }
      twitterTitle
    }
    fragment ArticleCard on WpPost {
      id
      uri
      title
      content
      excerpt
      date(formatString: "ddd DD MMMM")
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 800)
            }
          }
        }
      }
    }
    fragment MenuFields on WpMenu {
      menuItems {
        nodes {
          id
          label
          path
          parentId
          order
          childItems {
            nodes {
              id
              label
              path
              order
            }
          }
        }
      }
    }
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      wp {
        generalSettings {
          title
          url
        }
      }
      headerLeft: allWpMenu(filter: { locations: { eq: HEADER_LEFT } }) {
        nodes {
          ...MenuFields
        }
      }
      headerRight: allWpMenu(filter: { locations: { eq: HEADER_RIGHT } }) {
        nodes {
          ...MenuFields
        }
      }
      footerBook: allWpMenu(filter: { locations: { eq: FOOTER_BOOK } }) {
        nodes {
          ...MenuFields
        }
      }
      footerExplore: allWpMenu(filter: { locations: { eq: FOOTER_EXPLORE } }) {
        nodes {
          ...MenuFields
        }
      }
    }
  `)
}

export default useLayoutQuery